import { TrevorIcon, TrevorIconName } from '../TrevorIcon';
import React, { FC } from 'react';
import {
  CharCountLabel,
  StyledTextArea,
  TextAreaContainer,
} from './TextArea.styles';
import styled from 'styled-components';

const MAX_LENGTH = 128;

type TextAreaProps = {
  startIconName?: TrevorIconName;
  value?: string;
  onChange: F<string>;
  maxLength?: number;
  withCharCounter?: boolean;
} & Omit<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  'value' | 'onChange'
>;

export const TextArea: FC<TextAreaProps> = ({
  startIconName,
  maxLength = MAX_LENGTH,
  withCharCounter,
  onChange,
  ...props
}) => {
  const charCounter = `${props.value?.length || 0} / ${maxLength}`;

  return (
    <TextAreaContainer>
      <StyledTextArea>
        {startIconName && <TrevorIcon name={startIconName} />}
        <textarea
          maxLength={maxLength}
          onChange={(e) => onChange(e.target.value)}
          {...props}
        />
        <TrevorIcon name="manually-expand" />
      </StyledTextArea>
      {withCharCounter && (
        <CharCountLabel disabled={props.disabled}>{charCounter}</CharCountLabel>
      )}
    </TextAreaContainer>
  );
};
